import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, StoreIcon, MapPinIcon, PhoneIcon, BanknoteIcon, CheckCircleIcon, LoaderIcon, UserIcon } from 'lucide-react';
const initialFormData = {
  businessName: '',
  vendorType: 'Spaza Shop',
  registrationNumber: '',
  province: 'Gauteng',
  city: '',
  streetAddress: '',
  area: '',
  contactPerson: '',
  phone: '',
  email: '',
  altPhone: '',
  commissionRate: 5,
  bankName: 'ABSA',
  accountNumber: '',
  branchCode: ''
};
export function AddVendor() {
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [generatedId, setGeneratedId] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'commissionRate' ? Number(value) : value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setFormSubmitted(true);
      setGeneratedId(`V-${Math.floor(100 + Math.random() * 900).toString()}`);
    }, 1500);
  };
  const handleReset = () => {
    setFormData(initialFormData);
    setFormSubmitted(false);
    setGeneratedId('');
  };
  const Label = ({
    children,
    required
  }: {
    children: React.ReactNode;
    required?: boolean;
  }) => <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-300">
      {children}
      {required && <span className="text-red-500 ml-1" data-id="element-301">*</span>}
    </label>;
  const inputClasses = 'w-full px-3 py-2.5 border border-gray-300 rounded-none text-sm focus:ring-2 focus:ring-mavis-teal focus:border-mavis-teal outline-none transition-colors bg-white';
  if (formSubmitted) {
    return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-302">
        <div className="mb-8" data-id="element-303">
          <Link to="/vendors" className="inline-flex items-center text-mavis-teal hover:underline text-sm font-medium mb-4" data-id="element-304">

            <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-305" /> Back to Vendors
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-306">
            Add New Vendor
          </h1>
          <p className="text-gray-500" data-id="element-307">
            Register a new community vendor to the MAVIS vending network.
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-white border border-gray-200 shadow-sm rounded-none p-8 text-center" data-id="element-308">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-309">
            <CheckCircleIcon className="w-8 h-8 text-green-600" data-id="element-310" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-311">
            Vendor Registered Successfully!
          </h2>
          <p className="text-gray-500 mb-8" data-id="element-312">
            The vendor has been added to the system and is ready to start
            vending.
          </p>

          <div className="bg-gray-50 border border-gray-100 p-6 text-left mb-8" data-id="element-313">
            <div className="grid grid-cols-2 gap-y-4 gap-x-8" data-id="element-314">
              <div data-id="element-315">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-316">
                  Vendor ID
                </p>
                <p className="font-mono font-bold text-mavis-teal text-lg" data-id="element-317">
                  {generatedId}
                </p>
              </div>
              <div data-id="element-318">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-319">
                  Business Name
                </p>
                <p className="font-medium text-gray-900" data-id="element-320">
                  {formData.businessName}
                </p>
              </div>
              <div data-id="element-321">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-322">
                  Vendor Type
                </p>
                <p className="font-medium text-gray-900" data-id="element-323">
                  {formData.vendorType}
                </p>
              </div>
              <div data-id="element-324">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-325">
                  Location
                </p>
                <p className="font-medium text-gray-900" data-id="element-326">
                  {formData.city || formData.area || 'N/A'}
                </p>
              </div>
              <div data-id="element-327">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-328">
                  Contact Person
                </p>
                <p className="font-medium text-gray-900" data-id="element-329">
                  {formData.contactPerson}
                </p>
              </div>
              <div data-id="element-330">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-331">
                  Commission Rate
                </p>
                <p className="font-mono font-bold text-gray-900" data-id="element-332">
                  {formData.commissionRate}%
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-333">
            <button onClick={handleReset} className="bg-white border border-gray-300 text-gray-700 px-6 py-3 rounded-none hover:bg-gray-50 font-medium transition-colors" data-id="element-334">

              Add Another Vendor
            </button>
            <Link to="/vendors" className="bg-mavis-teal text-white px-6 py-3 font-medium rounded-none hover:bg-mavis-teal/90 shadow-sm transition-colors inline-block" data-id="element-335">

              Back to Vendors
            </Link>
          </div>
        </div>
      </div>;
  }
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-336">
      {/* Header */}
      <div className="mb-8" data-id="element-337">
        <Link to="/vendors" className="inline-flex items-center text-mavis-teal hover:underline text-sm font-medium mb-4" data-id="element-338">

          <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-339" /> Back to Vendors
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-340">
          Add New Vendor
        </h1>
        <p className="text-gray-500" data-id="element-341">
          Register a new community vendor to the MAVIS vending network.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-342">
        {/* Form Column */}
        <div className="lg:col-span-2" data-id="element-343">
          <form onSubmit={handleSubmit} className="bg-white border border-gray-200 shadow-sm rounded-none" data-id="element-344">

            {/* Section 1 - Business Information */}
            <div className="p-6 border-b border-gray-100" data-id="element-345">
              <div className="flex items-center gap-2 mb-6" data-id="element-346">
                <StoreIcon className="w-5 h-5 text-mavis-teal" data-id="element-347" />
                <h2 className="text-lg font-bold text-gray-900" data-id="element-348">
                  Business Information
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-349">
                <div className="md:col-span-2" data-id="element-350">
                  <Label required data-id="element-351">Vendor / Business Name</Label>
                  <input type="text" name="businessName" value={formData.businessName} onChange={handleChange} required className={inputClasses} placeholder="e.g. Soweto Superette" data-id="element-352" />

                </div>
                <div data-id="element-353">
                  <Label data-id="element-354">Vendor Type</Label>
                  <div className="relative" data-id="element-355">
                    <select name="vendorType" value={formData.vendorType} onChange={handleChange} className={`${inputClasses} appearance-none pr-10`} data-id="element-356">

                      <option value="Spaza Shop" data-id="element-357">Spaza Shop</option>
                      <option value="Supermarket" data-id="element-358">Supermarket</option>
                      <option value="Mini-Mart" data-id="element-359">Mini-Mart</option>
                      <option value="Corner Store" data-id="element-360">Corner Store</option>
                      <option value="Online/App" data-id="element-361">Online/App</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500" data-id="element-362">
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-363">

                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-364" />

                      </svg>
                    </div>
                  </div>
                </div>
                <div data-id="element-365">
                  <Label data-id="element-366">Registration Number</Label>
                  <input type="text" name="registrationNumber" value={formData.registrationNumber} onChange={handleChange} className={inputClasses} placeholder="e.g. 2024/123456/07" data-id="element-367" />

                </div>
              </div>
            </div>

            {/* Section 2 - Location Details */}
            <div className="p-6 border-b border-gray-100" data-id="element-368">
              <div className="flex items-center gap-2 mb-6" data-id="element-369">
                <MapPinIcon className="w-5 h-5 text-mavis-teal" data-id="element-370" />
                <h2 className="text-lg font-bold text-gray-900" data-id="element-371">
                  Location Details
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-372">
                <div className="md:col-span-2" data-id="element-373">
                  <Label data-id="element-374">Street Address</Label>
                  <input type="text" name="streetAddress" value={formData.streetAddress} onChange={handleChange} className={inputClasses} placeholder="e.g. 142 Vilakazi St" data-id="element-375" />

                </div>
                <div data-id="element-376">
                  <Label data-id="element-377">Area / Suburb</Label>
                  <input type="text" name="area" value={formData.area} onChange={handleChange} className={inputClasses} placeholder="e.g. Orlando West" data-id="element-378" />

                </div>
                <div data-id="element-379">
                  <Label data-id="element-380">City / Town</Label>
                  <input type="text" name="city" value={formData.city} onChange={handleChange} className={inputClasses} placeholder="e.g. Soweto" data-id="element-381" />

                </div>
                <div className="md:col-span-2" data-id="element-382">
                  <Label data-id="element-383">Province</Label>
                  <div className="relative" data-id="element-384">
                    <select name="province" value={formData.province} onChange={handleChange} className={`${inputClasses} appearance-none pr-10`} data-id="element-385">

                      <option value="Gauteng" data-id="element-386">Gauteng</option>
                      <option value="KwaZulu-Natal" data-id="element-387">KwaZulu-Natal</option>
                      <option value="Western Cape" data-id="element-388">Western Cape</option>
                      <option value="Eastern Cape" data-id="element-389">Eastern Cape</option>
                      <option value="Mpumalanga" data-id="element-390">Mpumalanga</option>
                      <option value="Limpopo" data-id="element-391">Limpopo</option>
                      <option value="Free State" data-id="element-392">Free State</option>
                      <option value="North West" data-id="element-393">North West</option>
                      <option value="Northern Cape" data-id="element-394">Northern Cape</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500" data-id="element-395">
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-396">

                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-397" />

                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3 - Contact Information */}
            <div className="p-6 border-b border-gray-100" data-id="element-398">
              <div className="flex items-center gap-2 mb-6" data-id="element-399">
                <PhoneIcon className="w-5 h-5 text-mavis-teal" data-id="element-400" />
                <h2 className="text-lg font-bold text-gray-900" data-id="element-401">
                  Contact Information
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-402">
                <div className="md:col-span-2" data-id="element-403">
                  <Label required data-id="element-404">Contact Person Name</Label>
                  <div className="relative" data-id="element-405">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-406">
                      <UserIcon className="h-4 w-4 text-gray-400" data-id="element-407" />
                    </div>
                    <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} required className={`${inputClasses} pl-10`} placeholder="e.g. Thabo Mbeki" data-id="element-408" />

                  </div>
                </div>
                <div data-id="element-409">
                  <Label required data-id="element-410">Phone Number</Label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className={inputClasses} placeholder="+27 XX XXX XXXX" data-id="element-411" />

                </div>
                <div data-id="element-412">
                  <Label data-id="element-413">Alternative Phone</Label>
                  <input type="tel" name="altPhone" value={formData.altPhone} onChange={handleChange} className={inputClasses} placeholder="+27 XX XXX XXXX" data-id="element-414" />

                </div>
                <div className="md:col-span-2" data-id="element-415">
                  <Label required data-id="element-416">Email Address</Label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required className={inputClasses} placeholder="e.g. contact@store.co.za" data-id="element-417" />

                </div>
              </div>
            </div>

            {/* Section 4 - Commission & Banking */}
            <div className="p-6 border-b border-gray-100" data-id="element-418">
              <div className="flex items-center gap-2 mb-6" data-id="element-419">
                <BanknoteIcon className="w-5 h-5 text-mavis-teal" data-id="element-420" />
                <h2 className="text-lg font-bold text-gray-900" data-id="element-421">
                  Commission & Banking
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-422">
                <div data-id="element-423">
                  <Label data-id="element-424">Commission Rate (%)</Label>
                  <div className="relative" data-id="element-425">
                    <input type="number" name="commissionRate" value={formData.commissionRate} onChange={handleChange} min="1" max="15" step="0.1" className={`${inputClasses} pr-8 font-mono`} data-id="element-426" />

                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-427">
                      <span className="text-gray-500 font-medium" data-id="element-428">%</span>
                    </div>
                  </div>
                </div>
                <div data-id="element-429">
                  <Label data-id="element-430">Bank Name</Label>
                  <div className="relative" data-id="element-431">
                    <select name="bankName" value={formData.bankName} onChange={handleChange} className={`${inputClasses} appearance-none pr-10`} data-id="element-432">

                      <option value="ABSA" data-id="element-433">ABSA</option>
                      <option value="FNB" data-id="element-434">FNB</option>
                      <option value="Standard Bank" data-id="element-435">Standard Bank</option>
                      <option value="Nedbank" data-id="element-436">Nedbank</option>
                      <option value="Capitec" data-id="element-437">Capitec</option>
                      <option value="African Bank" data-id="element-438">African Bank</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500" data-id="element-439">
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-440">

                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-441" />

                      </svg>
                    </div>
                  </div>
                </div>
                <div data-id="element-442">
                  <Label data-id="element-443">Account Number</Label>
                  <input type="text" name="accountNumber" value={formData.accountNumber} onChange={handleChange} className={`${inputClasses} font-mono`} placeholder="e.g. 1234567890" data-id="element-444" />

                </div>
                <div data-id="element-445">
                  <Label data-id="element-446">Branch Code</Label>
                  <input type="text" name="branchCode" value={formData.branchCode} onChange={handleChange} className={`${inputClasses} font-mono`} placeholder="e.g. 250655" data-id="element-447" />

                </div>
              </div>
            </div>

            {/* Form Actions */}
            <div className="p-6 bg-gray-50 flex items-center justify-end gap-4" data-id="element-448">
              <Link to="/vendors" className="px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-none hover:bg-gray-50 transition-colors" data-id="element-449">

                Cancel
              </Link>
              <button type="submit" disabled={isSubmitting} className="px-6 py-3 bg-mavis-teal text-white font-medium rounded-none hover:bg-mavis-teal/90 shadow-sm transition-colors flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-450">

                {isSubmitting ? <>
                    <LoaderIcon className="w-5 h-5 animate-spin" data-id="element-451" />
                    Registering...
                  </> : 'Register Vendor'}
              </button>
            </div>
          </form>
        </div>

        {/* Summary Sidebar */}
        <div className="lg:col-span-1" data-id="element-452">
          <div className="sticky top-8 bg-white border border-gray-200 shadow-sm rounded-none overflow-hidden" data-id="element-453">
            <div className="p-4 border-b border-gray-100 bg-gray-50" data-id="element-454">
              <h3 className="font-bold text-gray-900" data-id="element-455">Registration Summary</h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-456">
              <div data-id="element-457">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-458">
                  Business Details
                </p>
                {formData.businessName ? <>
                    <p className="font-bold text-gray-900" data-id="element-459">
                      {formData.businessName}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-460">
                      {formData.vendorType}
                    </p>
                  </> : <p className="text-sm text-gray-400 italic" data-id="element-461">
                    Not entered yet
                  </p>}
              </div>

              <div data-id="element-462">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-463">
                  Location
                </p>
                {formData.city || formData.area || formData.province ? <p className="text-sm text-gray-900" data-id="element-464">
                    {[formData.area, formData.city, formData.province].filter(Boolean).join(', ')}
                  </p> : <p className="text-sm text-gray-400 italic" data-id="element-465">
                    Not entered yet
                  </p>}
              </div>

              <div data-id="element-466">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-467">
                  Contact Person
                </p>
                {formData.contactPerson ? <>
                    <p className="text-sm font-medium text-gray-900" data-id="element-468">
                      {formData.contactPerson}
                    </p>
                    {formData.phone && <p className="text-sm text-gray-600" data-id="element-469">{formData.phone}</p>}
                    {formData.email && <p className="text-sm text-gray-600" data-id="element-470">{formData.email}</p>}
                  </> : <p className="text-sm text-gray-400 italic" data-id="element-471">
                    Not entered yet
                  </p>}
              </div>

              <div className="pt-6 border-t border-gray-100" data-id="element-472">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2" data-id="element-473">
                  Commission Setup
                </p>
                <div className="flex justify-between items-center mb-2" data-id="element-474">
                  <span className="text-sm text-gray-600" data-id="element-475">Rate</span>
                  <span className="font-mono font-bold text-mavis-teal" data-id="element-476">
                    {formData.commissionRate}%
                  </span>
                </div>
                <div className="bg-mavis-teal/5 p-3 rounded-none border border-mavis-teal/10" data-id="element-477">
                  <p className="text-xs text-gray-600 mb-1" data-id="element-478">
                    Estimated monthly commission based on R50,000 average sales:
                  </p>
                  <p className="font-mono font-bold text-gray-900" data-id="element-479">
                    R{' '}
                    {(50000 * (formData.commissionRate / 100)).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}